/**
 * possible statuses
 *
 * https://bitbucket.hotterpads.com/projects/RP/repos/transactions/browse/leasing/src/main/java/com/hotpads/leasing/model/enums/connectedzrm/ZrmStatusText.java
 */

const LEASE_STATUS = {
  ACTIVE: 'active',
  ACTIVE_EXPIRING_SOON: 'active expiring soon',
  AWAITING_YOUR_SIGNATURE: 'awaiting your signature',
  COMPLETE_DRAFT: 'draft completed',
  EXPIRED: 'expired',
  INCOMPLETE_DRAFT: 'draft incomplete',
  // Backend returns "SIGNING_CANCELLED" (2 "l"s) but we want "canceled" with only "l" to appear as text.
  SIGNING_CANCELLED: 'signing canceled',
  SIGNING_COMPLETE: 'signing completed',
  SIGNING_IN_PROGRESS: 'signing in progress',
  SIGNING_OFFLINE: 'signed offline',
};

export { LEASE_STATUS };
